import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { VehicleType } from '@app/entities/enums/ptrab/vehicle-type.enum';
import { LicensePlateRequest, LicensePlates } from '@app/entities/models/ptrab/license-plates/license-plates.model';

export interface LicensePlatesRepository {
  getLicensePlates(): Observable<LicensePlates>;
  createLicensePlate(licensePlate: LicensePlateRequest, vehicleType: VehicleType): Observable<object>;
  updateLicensePlate(
    licensePlate: LicensePlateRequest,
    vehicleType: VehicleType,
    vehicleId: string
  ): Observable<object>;
  deleteLicensePlate(vehicleType: VehicleType, vehicleId: string): Observable<object>;
}

export const LICENSE_PLATES_REPOSITORY = new InjectionToken<LicensePlatesRepository>('LICENSE_PLATES_REPOSITORY');
